/**
 * Provides utilities for validating web domains.
 *
 * @module WebDomainValidator
 * @see {@link https://emailregex.com/} (minus IP and user patterns)
 */
/**
 * The default regex pattern used to validate web domains.
 * This pattern conforms to the general email format, with the user/IP portions excluded.
 * Note that this does not match some legit use-cases: domains with unicode characters,
 * eg. fåcebook.com, due to the likelihood this is a malicious actor.
 *
 * @constant
 * @type {RegExp}
 */
export const REGEX_WEBDOMAIN_VALIDATOR_PATTERN = /^([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/;
/**
 * The error message used when an expected regex pattern is not set.
 *
 * @constant
 * @type {string}
 */
export const REGEX_WEBDOMAIN_VALIDATOR_ERROR = 'Regular expression for web domain validations not set';
export class WebDomainValidator {
    constructor(regex = REGEX_WEBDOMAIN_VALIDATOR_PATTERN) {
        this.regex = regex;
        if (!regex) {
            throw new Error(REGEX_WEBDOMAIN_VALIDATOR_ERROR);
        }
    }
    validate(webDomain) {
        return this.regex.test(webDomain);
    }
}
//# sourceMappingURL=WebDomainValidator.js.map